import { css} from 'styled-components';

export const CommonCardStyles = css`
gap: 10px;
font-weight: bold;
padding: 10px;
align-items: center;

&:hover {
  cursor: pointer;
}
& .name {
  color: blue;
}
`;